export default __webpack_public_path__ + "static/media/nextIcon.76de10e3.svg";